import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className={`block will-change-transform ${innerClassName}`}
      initial={{ y: "115%", rotate: 2.5 }}
      whileInView={{ y: "0%", rotate: 0 }}
      viewport={{ once: true, margin: "0px 0px -6% 0px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "0px 0px -6% 0px" }}
    transition={{ duration: 0.85, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
